import React from 'react';
import styled from 'styled-components';

import WP from 'WP';

import UserIcon from 'icons/UserIcon';

import FavoriteButton from 'partials/FavoriteButton';
import SmartLink from 'partials/SmartLink';

import Media from 'css/Media';

export const VenueFeatures = props => {
    
    const { venue } = props;    
    if(!venue.acf.venue_web_site) return null;
    return (
        <Wrapper>
            <Capacity>
                <UserIcon />
                <span>{venue.acf.capacity_from} - {venue.acf.capacity_to} {WP.trans.persons}</span>
            </Capacity>
            <SmartLink to={venue.acf.venue_web_site}>{venue.acf.venue_web_site}</SmartLink>
            <FavoriteButton sort={venue.type} item={venue} />
        </Wrapper>
    )
}

export default VenueFeatures;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
        color: ${props => props.theme.colors.link};
        text-decoration: underline;

        &:hover, &:active {
            text-decoration: none;
        }

        ${Media.greaterThan('s')`
            //margin-right: ${props => props.theme.spacing.contentXL};
            margin-right: 66px;
        `}
    }

    ${Media.greaterThan('s')`
        justify-content: flex-start;
    `}
`

const Capacity = styled.div`
    display: flex;
    align-items: center;
    
    svg {
        margin-right: ${props => props.theme.spacing.contentXS};

        ${Media.greaterThan('s')`
            margin-right: ${props => props.theme.spacing.contentS};
        `}
    }

    ${Media.greaterThan('s')`
        margin-right: ${props => props.theme.spacing.elementXS};
    `}
`